"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./style.scss");
const app_1 = require("./app/app");
const button_1 = require("./app/view-components/buttons/button");
const app = new app_1.App();
app.run();
(0, button_1.mouseOnButton)();
